import { useDocumentListener } from './useDocumentListener';
export function useEscKeyHandler(fn, active = true) {
    useDocumentListener('keydown', (e) => {
        const isEscape = e.key === 'Escape' || e.key === 'Esc';
        const isActive = typeof active === 'function' ? active(e) : active;
        if (!isEscape || !isActive) {
            return;
        }
        fn(e);
    });
}
//# sourceMappingURL=useEscKeyHandler.js.map